import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import Style from './Curriculum.cssmodule.less';
import { clickButton } from '../../actions/Modal';
import classNames from 'classnames';

class CurriculumStudyComplete extends BaseComponent {
    constructor(props) {
        super(props);
        this.contentMap = {
            DONE: {
                className: Style.small_pop_wrap,
                title: '실습활동 완료',
                content: () => <div>
                    축하합니다!<br/> 실습 활동을 완료했습니다.
                    </div>,
                btn1: '다시하기',
                btn2: '완료하기',
            },
            SUCCESS: {
                className: classNames(Style.result_pop_wrap, Style.success),
                title: '성공',
                content: () => <div><strong className={Style.sjt}>성공!</strong><p className={Style.dsc}>오, 멋지게 해결했네요!</p></div>,
                btn1: '다시하기',
                btn2: '다음단계 가기',
            },
            FAIL: {
                className: classNames(Style.result_pop_wrap, Style.fail),
                title: '실패',
                content: (text) => <div><strong className={Style.sjt}>실패</strong><p className={Style.dsc}>{text}</p></div>,
                btn1: '다시하기',
            },
        };
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({ event });
    }

    render() {
        const { item = {} } = this.props;
        const { contentType = 'DONE', message = '', title: itemTitle } = item;
        const { title, content, btn1, btn2, className } = this.contentMap[contentType];

        return (
            <div>
                {/* 실습활동 완료  */}
                <div className={className}>
                    {title && <div className={Style.pop_header}>
                        <strong className={Style.sjt}>{itemTitle || title}</strong>
                    </div>}
                    <div className={Style.pop_cont}>
                        {content(message)}
                    </div>
                    <div className={Style.pop_btn_box}>
                        <span className={classNames(Style.btn)} onClick={() => this.handleButtonClick('prev')}>{btn1}</span>
                        {btn2 && <span className={classNames(Style.btn, Style.active)} onClick={() => this.handleButtonClick('next')}>{btn2}</span>}
                    </div>
                    {title &&
                    <span className={Style.pop_close} onClick={() => this.handleButtonClick('close')}>팝업닫기</span>}
                </div>
            </div>
        );
    }
}

CurriculumStudyComplete.displayName = 'CurriculumStudyComplete';
CurriculumStudyComplete.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps,
)(CurriculumStudyComplete);



// WEBPACK FOOTER //
// ./components/ModalSet/CurriculumStudyComplete.js